<template>
  <div>
    <PCNavbar selectIndex="10"/>
    <MobileNavBar :currentActive="9" />
    <lca/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import lca from '@/components/lca/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    lca
  },
}
</script>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>